// import React, { useState } from "react";
// import { Dropdown } from "react-bootstrap";
// import "../../../styles/sellers-table.css";

// export default function SellersTable({
//   sellers = [],
//   onStatusChange,
//   onApprove,
//   onDelete,
// }) {
//   const [expandedRow, setExpandedRow] = useState(null);

//   const getLicenseUrl = (path) =>
//     path
//       ? `https://auth.afrogebeya.com/uploads/licenses/${path.replace(
//           /^.*\/afrogebeya\/licenses/,
//           "",
//         )}`
//       : null;

//   if (!sellers.length) {
//     return <p className="text-center text-muted">No sellers found.</p>;
//   }

//   const StatusBadge = ({ status }) => (
//     <span
//       className={`badge bg-${status === "ACTIVE" ? "success" : "secondary"}`}
//     >
//       {status}
//     </span>
//   );

//   const VerifiedBadge = ({ verified }) => (
//     <span className={`badge bg-${verified ? "success" : "warning"}`}>
//       {verified ? "Yes" : "No"}
//     </span>
//   );

//   return (
//     <div className="">
//       {/* ================= DESKTOP TABLE ================= */}
//       <table className="table table-hover table-sm align-middle d-none d-md-table">
//         <thead className="table-light">
//           <tr>
//             <th>Company</th>
//             <th>Owner</th>
//             <th>Email</th>
//             <th>Phone</th>
//             <th>Status</th>
//             <th>Verified</th>
//             <th>License</th>
//             <th>Created</th>
//             <th style={{ width: 120 }}>Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {sellers.map((seller) => {
//             const licenseUrl = getLicenseUrl(seller.businessLicensePath);

//             return (
//               <tr key={seller.id}>
//                 <td>{seller.companyName || "-"}</td>
//                 <td>{seller.fullName || "-"}</td>
//                 <td>{seller.email}</td>
//                 <td>{seller.phone}</td>

//                 <td>
//                   <StatusBadge status={seller.status} />
//                 </td>

//                 <td>
//                   <VerifiedBadge verified={seller.licenseVerified} />
//                 </td>

//                 <td>
//                   {licenseUrl ? (
//                     <a href={licenseUrl} target="_blank" rel="noreferrer">
//                       View
//                     </a>
//                   ) : (
//                     "-"
//                   )}
//                 </td>

//                 <td>
//                   {seller.createdAt
//                     ? new Date(seller.createdAt).toLocaleDateString()
//                     : "-"}
//                 </td>

//                 <td>
//                   <Dropdown align="end">
//                     <Dropdown.Toggle
//                       size="sm"
//                       variant="outline-secondary"
//                       id={`actions-${seller.id}`}
//                     >
//                       Actions
//                     </Dropdown.Toggle>

//                     <Dropdown.Menu>
//                       <Dropdown.Item onClick={() => onStatusChange(seller.id)}>
//                         Activate / Deactivate
//                       </Dropdown.Item>

//                       {!seller.licenseVerified && (
//                         <Dropdown.Item onClick={() => onApprove(seller.id)}>
//                           Verify Seller
//                         </Dropdown.Item>
//                       )}

//                       <Dropdown.Divider />

//                       <Dropdown.Item
//                         className="text-danger"
//                         onClick={() => onDelete(seller.id)}
//                       >
//                         Delete
//                       </Dropdown.Item>
//                     </Dropdown.Menu>
//                   </Dropdown>
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>

//       {/* ================= MOBILE CARDS ================= */}
//       <div className="d-md-none">
//         {sellers.map((seller) => {
//           const isExpanded = expandedRow === seller.id;
//           const licenseUrl = getLicenseUrl(seller.businessLicensePath);

//           return (
//             <div key={seller.id} className="card mb-2 shadow-sm">
//               <div className="card-body">
//                 <div className="d-flex justify-content-between align-items-center">
//                   <div>
//                     <h6 className="mb-1">{seller.companyName || "-"}</h6>
//                     <p className="mb-0 text-muted">{seller.email}</p>
//                     <p className="mb-0 text-muted">{seller.phone}</p>
//                   </div>

//                   <button
//                     className="btn btn-sm btn-outline-secondary"
//                     onClick={() =>
//                       setExpandedRow(isExpanded ? null : seller.id)
//                     }
//                   >
//                     {isExpanded ? "Hide Details" : "View Details"}
//                   </button>
//                 </div>

//                 {isExpanded && (
//                   <div className="mt-3">
//                     <p className="mb-1">
//                       <strong>Owner:</strong> {seller.fullName || "-"}
//                     </p>

//                     <p className="mb-1">
//                       <strong>Status:</strong>{" "}
//                       <StatusBadge status={seller.status} />
//                     </p>

//                     <p className="mb-1">
//                       <strong>Verified:</strong>{" "}
//                       <VerifiedBadge verified={seller.licenseVerified} />
//                     </p>

//                     <p className="mb-1">
//                       <strong>License:</strong>{" "}
//                       {licenseUrl ? (
//                         <a href={licenseUrl} target="_blank" rel="noreferrer">
//                           View
//                         </a>
//                       ) : (
//                         "-"
//                       )}
//                     </p>

//                     <p className="mb-2">
//                       <strong>Created:</strong>{" "}
//                       {seller.createdAt
//                         ? new Date(seller.createdAt).toLocaleDateString()
//                         : "-"}
//                     </p>

//                     <Dropdown className="w-100">
//                       <Dropdown.Toggle
//                         size="sm"
//                         variant="outline-secondary"
//                         className="w-100"
//                       >
//                         Actions
//                       </Dropdown.Toggle>

//                       <Dropdown.Menu className="w-100">
//                         <Dropdown.Item
//                           onClick={() => onStatusChange(seller.id)}
//                         >
//                           Activate / Deactivate
//                         </Dropdown.Item>

//                         {!seller.licenseVerified && (
//                           <Dropdown.Item onClick={() => onApprove(seller.id)}>
//                             Verify Seller
//                           </Dropdown.Item>
//                         )}

//                         <Dropdown.Divider />

//                         <Dropdown.Item
//                           className="text-danger"
//                           onClick={() => onDelete(seller.id)}
//                         >
//                           Delete
//                         </Dropdown.Item>
//                       </Dropdown.Menu>
//                     </Dropdown>
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import "../../../styles/sellers-table.css";

export default function SellersTable({
  sellers = [],
  onStatusChange,
  onApprove,
  onDelete,
}) {
  const [expandedRow, setExpandedRow] = useState(null);
  const [actionLoading, setActionLoading] = useState(null);

  const getLicenseUrl = (path) =>
    path
      ? `https://auth.afrogebeya.com/uploads/licenses/${path.replace(
          /^.*\/afrogebeya\/licenses/,
          "",
        )}`
      : null;

  const handleAction = async (type, sellerId, extra) => {
    try {
      setActionLoading(sellerId);

      if (type === "status") {
        await onStatusChange(sellerId, extra);
      } else if (type === "approve") {
        await onApprove(sellerId);
      } else if (type === "delete") {
        await onDelete(sellerId);
      }
    } finally {
      setActionLoading(null);
    }
  };

  if (!sellers.length) {
    return <p className="text-center text-muted">No sellers found.</p>;
  }

  const StatusBadge = ({ status }) => (
    <span
      className={`badge bg-${status === "ACTIVE" ? "success" : "secondary"}`}
    >
      {status}
    </span>
  );

  const VerifiedBadge = ({ verified }) => (
    <span className={`badge bg-${verified ? "success" : "warning"}`}>
      {verified ? "Yes" : "No"}
    </span>
  );

  return (
    <div>
      {/* ================= DESKTOP TABLE ================= */}
      <table className="table table-hover table-sm align-middle d-none d-md-table">
        <thead className="table-light">
          <tr>
            <th>Company</th>
            <th>Owner</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
            <th>Verified</th>
            <th>License</th>
            <th>Created</th>
            <th style={{ width: 140 }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {sellers.map((seller) => {
            const licenseUrl = getLicenseUrl(seller.businessLicensePath);
            const isLoading = actionLoading === seller.id;

            return (
              <tr key={seller.id}>
                <td>{seller.companyName || "-"}</td>
                <td>{seller.fullName || "-"}</td>
                <td>{seller.email || "-"}</td>
                <td>{seller.phone || "-"}</td>

                <td>
                  <StatusBadge status={seller.status} />
                </td>

                <td>
                  <VerifiedBadge verified={seller.licenseVerified} />
                </td>

                <td>
                  {licenseUrl ? (
                    <a href={licenseUrl} target="_blank" rel="noreferrer">
                      View
                    </a>
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  {seller.createdAt
                    ? new Date(seller.createdAt).toLocaleDateString()
                    : "-"}
                </td>

                <td>
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      size="sm"
                      variant="outline-secondary"
                      disabled={isLoading}
                    >
                      {isLoading ? <Spinner size="sm" /> : "Actions"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() =>
                          handleAction(
                            "status",
                            seller.id,
                            seller.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
                          )
                        }
                      >
                        {seller.status === "ACTIVE" ? "Deactivate" : "Activate"}
                      </Dropdown.Item>

                      {!seller.licenseVerified && (
                        <Dropdown.Item
                          onClick={() => handleAction("approve", seller.id)}
                        >
                          Verify Seller
                        </Dropdown.Item>
                      )}

                      <Dropdown.Divider />

                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => handleAction("delete", seller.id)}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* ================= MOBILE CARDS ================= */}
      <div className="d-md-none">
        {sellers.map((seller) => {
          const isExpanded = expandedRow === seller.id;
          const licenseUrl = getLicenseUrl(seller.businessLicensePath);
          const isLoading = actionLoading === seller.id;

          return (
            <div key={seller.id} className="card mb-2 shadow-sm">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1">{seller.companyName || "-"}</h6>
                    <p className="mb-0 text-muted">{seller.email}</p>
                    <p className="mb-0 text-muted">{seller.phone}</p>
                  </div>

                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() =>
                      setExpandedRow(isExpanded ? null : seller.id)
                    }
                  >
                    {isExpanded ? "Hide" : "Details"}
                  </button>
                </div>

                {isExpanded && (
                  <div className="mt-3">
                    <p className="mb-1">
                      <strong>Owner:</strong> {seller.fullName || "-"}
                    </p>

                    <p className="mb-1">
                      <strong>Status:</strong>{" "}
                      <StatusBadge status={seller.status} />
                    </p>

                    <p className="mb-1">
                      <strong>Verified:</strong>{" "}
                      <VerifiedBadge verified={seller.licenseVerified} />
                    </p>

                    <p className="mb-1">
                      <strong>License:</strong>{" "}
                      {licenseUrl ? (
                        <a href={licenseUrl} target="_blank" rel="noreferrer">
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </p>

                    <p className="mb-2">
                      <strong>Created:</strong>{" "}
                      {seller.createdAt
                        ? new Date(seller.createdAt).toLocaleDateString()
                        : "-"}
                    </p>

                    <Dropdown className="w-100">
                      <Dropdown.Toggle
                        size="sm"
                        variant="outline-secondary"
                        className="w-100"
                        disabled={isLoading}
                      >
                        {isLoading ? <Spinner size="sm" /> : "Actions"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="w-100">
                        <Dropdown.Item
                          onClick={() =>
                            handleAction(
                              "status",
                              seller.id,
                              seller.status === "ACTIVE"
                                ? "INACTIVE"
                                : "ACTIVE",
                            )
                          }
                        >
                          {seller.status === "ACTIVE"
                            ? "Deactivate"
                            : "Activate"}
                        </Dropdown.Item>

                        {!seller.licenseVerified && (
                          <Dropdown.Item
                            onClick={() => handleAction("approve", seller.id)}
                          >
                            Verify Seller
                          </Dropdown.Item>
                        )}

                        <Dropdown.Divider />

                        <Dropdown.Item
                          className="text-danger"
                          onClick={() => handleAction("delete", seller.id)}
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
